import { Action, createReducer, on } from '@ngrx/store';
import * as newsActions from '../actions/news.actions';
import { Post, SocialMediaLinks } from '../interfaces';

export interface NewsState {
  articles: Array<Post>;
  loaded: boolean;
  socialMediaLinks: SocialMediaLinks;
}

export const initialState: NewsState = {
  articles: [],
  loaded: false,
  socialMediaLinks: {
    facebook: '',
    facebookSoccer: '',
    twitter: '',
    linkedin: '',
    pinterest: '',
    youtube: ''
  }
};

export const newsReducer = createReducer(
  initialState,
  on(newsActions.GetNewsSuccess, (state, action) => {
    return {
      ...state,
      articles: action.payload,
      loaded: true
    };
  }),
  on(newsActions.GetSocialMediaLinksSuccess, (state, action) => {
    return {
      ...state,
      socialMediaLinks: action.payload
    };
  })
);

export function reducer(
  state: NewsState | undefined,
  action: Action
): NewsState {
  return newsReducer(state, action);
}

export const getArticles = (state: NewsState) =>
  state && state.articles ? state.articles : [];

export const getLoadedStatus = (state: NewsState) =>
  state && state.loaded ? state.loaded : false;

export const getSocialMediaLinks = (state: NewsState) =>
  state && state.socialMediaLinks
    ? state.socialMediaLinks
    : initialState.socialMediaLinks;
